export class AgentCustomKPI{
    custom_kpi_id: number
    value: string = ''
    percents: string = ''

    constructor(custom_kpi_id: number){
        this.custom_kpi_id = custom_kpi_id
    }
}